import { canonicalRole, type Role } from "./roles";

/**
 * ระดับของคอนโซล (ADR-0016) — คนละเรื่องกับ role
 *
 * `officer` กับ `district_finance` ทำงานอยู่ระดับเมืองเหมือนกันแต่คนละหน้าที่
 * (ตาแสงตรวจ/เซ็นเอกสาร ส่วนการเงินดูตัวเลข) จอจึงใช้ชุดเดียวกัน แต่เมนูต่างกัน
 */
export type Tier = "district" | "province" | "system";

export const TIER_LABEL_LO: Record<Tier, string> = {
  district: "ການເງິນເມືອງ",
  province: "ກວດກາແຂວງ",
  system: "ຜູ້ບໍລິຫານລະບົບ",
};

/** ระดับที่ role นี้ทำงานอยู่ — `null` คือไม่ใช่คนหลังบ้าน (ประชาชน) */
export function tierOf(role: Role | null): Tier | null {
  if (!role) return null;
  switch (canonicalRole(role)) {
    case "officer":
    case "district_finance":
      return "district";
    case "province_oversight":
      return "province";
    case "super_admin":
      return "system";
    default:
      return null;
  }
}

/**
 * ระดับที่สูงกว่าเห็นจอของระดับที่ต่ำกว่าได้ (แขวงดูจอเมืองได้ ผู้ดูแลระบบดูได้หมด)
 * แต่ **ยังเห็นเฉพาะข้อมูลใน scope ของตัวเอง** เพราะ API กรองให้อีกชั้น —
 * ตัวนี้คุมแค่ว่าเมนูไหนโผล่ ไม่ใช่กลไกความปลอดภัย
 */
const REACH: Record<Tier, Tier[]> = {
  district: ["district"],
  province: ["province", "district"],
  system: ["system", "province", "district"],
};

export function canReach(actual: Tier | null, required: Tier): boolean {
  return actual !== null && REACH[actual].includes(required);
}

/**
 * หน้าแรกของแต่ละระดับ — ใช้ตอน redirect จาก `/`
 *
 * ค่าทุกตัวต้องเป็น **path ที่มี route จริง** ไม่งั้นจะวนกับ catch-all `*`
 * ที่เด้งกลับ `/` จนเบราว์เซอร์ค้าง (เคยเกิดมาแล้วตอนชี้ไป path ที่ยังไม่ได้ทำ)
 */
export const TIER_HOME: Record<Tier, string> = {
  // ทุกระดับใช้ Dashboard เดียวกัน — เริ่มที่ขอบเขตของบัญชีเอง (server กรอง scope)
  district: "/dashboard",
  province: "/dashboard",
  system: "/dashboard",
};
